(() => {
  if (window.PuzzlePupMultiBuy) return;
  const labels = () => window.PuzzlePupCroLabels || {};
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-pp-multi-buy]');
    if (!form) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (form.getAttribute('aria-busy') === 'true') return;
    const button = form.querySelector('[type="submit"]');
    const notice = form.querySelector('[data-pp-multi-error]');
    const original = button.textContent;
    const entries = [...form.querySelectorAll('[data-pp-multi-variant]')];
    const items = entries.map(input => ({ id: Number(input.value), quantity: Number(input.dataset.quantity || 1) }));
    const maximum = Number(form.dataset.expectedPrice);
    form.setAttribute('aria-busy', 'true');
    button.disabled = true;
    button.textContent = labels().adding || 'Adding…';
    if (notice) { notice.hidden = true; notice.textContent = ''; }
    try {
      if (!items.length || items.some(item => !item.id)) throw new Error(labels().error);
      if (!window.PuzzlePupOfferEngine?.addAndVerify) throw new Error(labels().error);
      await window.PuzzlePupOfferEngine.addAndVerify({ items, expectedMaxIncrease: maximum, offerId: form.dataset.offerId || 'multi-buy', source: window.location.pathname });
      await window.PuzzlePupOfferEngine.refreshCartSurfaces();
      const drawer = document.querySelector('cart-drawer');
      if (typeof drawer?.open === 'function') drawer.open();
      else window.location.assign((window.Shopify?.routes?.root || '/') + 'cart');
    } catch (error) {
      if (notice) { notice.hidden = false; notice.textContent = error.message || labels().error; }
    } finally {
      form.removeAttribute('aria-busy');
      button.disabled = false;
      button.textContent = original;
    }
  }, true);
  window.PuzzlePupMultiBuy = true;
})();
